<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>统计管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/user_in_data')">代理新增统计</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >

          <el-form-item label="查询时间">
            <el-form-item prop="startTime">
              <el-date-picker
                type="date"
                placeholder="选择开始日期"
                v-model="filters.startTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <span style="display: inline-block;margin-right: 9px;">-</span>
            <el-form-item prop="endTime">
              <el-date-picker
                type="date"
                placeholder="选择结束日期"
                v-model="filters.endTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>

          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >统计</el-button>

            <el-button
              style="margin-left:10px"
              @click="goDown"
              type="danger"
              size="small"
            >到底部</el-button>

            <el-button
              style="margin-left:10px"
              @click="goTop"
              type="warn"
              size="small"
            >到顶部</el-button>

          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <!-- <div class="contain_body_head">
          总金额：{{totalMoney}}
        </div> -->
        <el-table
          ref="dataTable"
          v-loading="listLoading"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="role_type"
            :formatter="formatterRoleType"
            label="代理级别"
          >
          </el-table-column>

          <el-table-column
            prop="total_num"
            label="新进代理人数"
          >
          </el-table-column>

          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <template>

                <el-button
                  @click="showDetailInfos(scope.row)"
                  type="text"
                  size="small"
                >查看明细</el-button>
                <el-button
                  style="margin-left:10px"
                  @click="excelOut(scope.row.role_type)"
                  type="text"
                  size="small"
                >导出</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

    </div>

    <el-dialog
      title="明细"
      :visible.sync="subListVisible"
      width="70%"
    >
      <div>

        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="subFilters"
        >
          <el-form-item label="区域总监">
            <el-select
              v-model="filters.districtUserId"
              filterable
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="option in userList"
                :value="option.userId"
                :key='option.userId'
                :label="option.username"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-button
            type="primary"
            @click="handleSubSearch"
          >查询</el-button>
        </el-form>
      </div>

      <el-table
        v-loading="detailListLoading"
        :data="tableDetailData"
        style="width: 100%"
        max-height="500"
        :header-cell-class-name='objectSpanMethod'
      >
        <el-table-column
          prop="role_type"
          :formatter="formatterRoleType"
          label="代理级别"
        >
        </el-table-column>

        <el-table-column
          prop="group_type"
          label="团队"
        >
        <template slot-scope="scope">
          <span v-if="scope.row.group_type == 1">陈</span>
          <span v-else>孙</span>
        </template>
        </el-table-column>

        <el-table-column
          prop="username"
          label="代理姓名"
        >
        </el-table-column>

        <el-table-column
          prop="telephone"
          label="代理手机号"
        >
        </el-table-column>

        <el-table-column
          prop="show_name"
          label="店铺名称"
        >
        </el-table-column>

        <el-table-column
          prop="telephone"
          label="上级信息"
        >
          <template slot-scope="scope">
            {{scope.row.up_name}}-{{scope.row.up_tel}}
          </template>
        </el-table-column>

        <el-table-column
          prop="create_time"
          label="升级时间"
        >
        </el-table-column>

      </el-table>
      <div class="pageDiv block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page_num"
          :page-count='total_page'
          :page-size="page_size"
          layout="total, prev, pager, next"
          :total="total_num"
        >
        </el-pagination>
      </div>

    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "userInData",
  created() {},
  data() {
    return {
      totalMoney: 0,
      subListVisible: false,
      listLoading: false,
      picList: [],
      askRoleType: null,
      filters: {
        status: null,
        startTime: null,
        title: null,
        userId: null,
        endTime: null
      },
      subFilters: {
        districtUserId: null,
      },
      page_num: 1,
      keywords: "",
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      detailListLoading: false,
      tableDetailData: [],
      tableHeight: null,
      userList: [],
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.topUserList()
    this.handleSearch();
  },
  methods: {
    handleSubSearch(){
      this.searchDetail(this.askRoleType);
    },
    topUserList(){
      let that = this
      let para = {
        token: localStorage.getItem("api_token")
      };
      API.top_user_list(para)
        .then(
          function(result) {
            if (result && parseInt(result.key) === 1000) {
              if (result.result.list != null && result.result.list.length > 0) {
                that.userList = result.result.list;
              } else {
                that.userList = [];
              }
            }
          },
          function(err) {
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    goDown(){
      this.$refs.dataTable.bodyWrapper.scrollTop =this.$refs.dataTable.bodyWrapper.scrollHeight;
    },
    goTop(){
      this.$refs.dataTable.bodyWrapper.scrollTop =0;
    },
    showDetailInfos(row) {
      let that = this;
      that.subListVisible = true;

      this.page_size = 10;
      this.page_num = 1;
      this.askRoleType = row.role_type;
      this.searchDetail(this.askRoleType);
    },
    searchDetail(role_type) {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        roleType: role_type,
        status: 3,
        pageNum: that.page_num,
        pageSize: that.page_size
      };
      if (that.filters.startTime) {
        para.beginFinishTime = that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        para.endFinishTime = that.filters.endTime.getTime();
      }
      if (that.filters.districtUserId){
        para.districtUserId = that.filters.districtUserId
      }
      that.detailListLoading = true;
      API.up_log_list(para)
        .then(
          function(result) {
            that.detailListLoading = false;
            that.total_num = result.result.count;
            that.total_page = result.result.allPageNumber;
            if (result && parseInt(result.key) === 1000) {
              if (result.result.list != null && result.result.list.length > 0) {
                that.tableDetailData = result.result.list;
              } else {
                that.tableDetailData = [];
              }
            }
          },
          function(err) {
            that.detailListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    excelOut(role_type) {
      var that = this;
      var url =
        "/manager/user/pc/in_user_num_list_excel?token=" +
        localStorage.getItem("api_token");
      url = url + "&status=3";
      url = url + "&roleType=" + role_type;
      if (that.filters.startTime) {
        url = url + "&beginFinishTime=" + that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        url = url + "&endFinishTime=" + that.filters.endTime.getTime();
      }
      top.location.href = url;
    },
    handleSearch() {
      this.search();
    },
    formatterRoleType(row, column) {
      if (row.role_type == 0) {
        return "VIP门店";
      } else if (row.role_type == 1) {
        return "联盟店";
      } else if (row.role_type == -0.5) {
        return "康减系列vip会员";
      } else if (row.role_type == -0.4) {
        return "康减系列高级会员";
      } else if (row.role_type == -0.3) {
        return "康减系列荣誉会员";
      } else if (row.role_type == 2) {
        return "市代";
      } else if (row.role_type == 3) {
        return "省代";
      } else if (row.role_type == 4) {
        return "CEO";
      } else if (row.role_type == 1.1) {
        return "康减系列市代";
      } else if (row.role_type == 2.1) {
        return "康减系列省代";
      } else if (row.role_type == 3.1) {
        return "康减系列CEO";
      } else if (row.role_type == 1.05) {
        return "优秀联盟店";
      } else if (row.role_type == 5) {
        return "总经销商";
      } else if (row.role_type == 2.2) {
        return "合伙人";
      } else if (row.role_type == 4.2) {
        return "董事";
      } else if (row.role_type == 5.1) {
        return "区域总监";
      } else if (row.role_type == 5.2) {
        return "城市加盟商";
      } else if (row.role_type == 4.8) {
        return "经销商";
      }
    },

    search() {
      let that = this;
      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.startTime) {
        params.beginTime = that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      }

      that.listLoading = true;
      API.in_user_num_list(params)
        .then(
          function(result) {
            that.listLoading = false;
            if (result.key == 1000) {
              var list = [
                { role_type: -0.5, total_num: 0 },
                { role_type: -0.4, total_num: 0 },
                { role_type: -0.3, total_num: 0 },
                { role_type: 1.1, total_num: 0 },
                { role_type: 2.1, total_num: 0 },
                { role_type: 3.1, total_num: 0 },
                { role_type: 0, total_num: 0 },
                { role_type: 1, total_num: 0 },
                { role_type: 1.05, total_num: 0 },
                { role_type: 2.2, total_num: 0 },
                { role_type: 4.2, total_num: 0 },
                { role_type: 5.1, total_num: 0 },
                { role_type: 2, total_num: 0 },
                { role_type: 3, total_num: 0 },
                { role_type: 4, total_num: 0 }
              ];
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  for (var j = 0; j < list.length; j++) {
                    if (
                      list[j]["role_type"] == result.result.list[i]["role_type"]
                    ) {
                      list[j]["total_num"] = result.result.list[i]["total_num"];
                    }
                  }
                }
              }
              that.tableData = list;
            }
          },
          function(err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.searchDetail(this.askRoleType);
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/userInData.vue